export default "__VITE_ASSET__CYU$LGa8__"